import { Notifier } from "@airbrake/browser";
import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { ENVIRONMENT, isProductionOrStaging } from "@/utils/environment";

function AirbrakeErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    if (isRouteErrorResponse(error)) return;

    if (isProductionOrStaging()) {
      const airbrake = new Notifier({
        environment: ENVIRONMENT,
        projectId: Number(import.meta.env.VITE_AIRBRAKE_PROJECT_ID),
        projectKey: import.meta.env.VITE_AIRBRAKE_PROJECT_KEY,
      });

      airbrake.notify({ error });
    } else {
      console.log("[Airbrake]", { error });
    }
  }, [error]);

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center text-center">
      <h1 className="text-2xl font-bold">Something went wrong</h1>
      <p className="mt-2 max-w-5/6">
        We've been notified and are looking into it. Please try refreshing the
        page.
      </p>
    </div>
  );
}

export default AirbrakeErrorBoundary;
